import yaml from 'js-yaml';
import Papa from 'papaparse';

export const exportSaves = (saves, format) => {
  switch (format) {
    case 'json':
      return {
        content: JSON.stringify(saves, null, 2),
        mimeType: 'application/json',
        fileExtension: 'json',
      };
    case 'yaml':
      return {
        content: yaml.dump(saves),
        mimeType: 'application/x-yaml',
        fileExtension: 'yaml',
      };
    case 'txt':
      const txtContent = saves.map(save => `${save.title}\n${save.url}\n\n`).join('');
      return {
        content: txtContent,
        mimeType: 'text/plain',
        fileExtension: 'txt',
      };
    case 'csv':
      const csvContent = Papa.unparse(saves.map(save => ({
        title: save.title,
        url: save.url,
        tags: save.tags ? save.tags.map(t => t.name).join(', ') : '',
        createdAt: save.createdAt,
      })));
      return {
        content: csvContent,
        mimeType: 'text/csv',
        fileExtension: 'csv',
      };
    default:
      throw new Error(`Unsupported format: ${format}`);
  }
};
